<template>
    <div class="flex flex-col lg:flex-row h-screen w-screen">
        <!-- 左侧菜单导航栏 -->
        <NavBar
            :headerService="headerService"
            :navModuleType="NAV_MENU_TYPE.VAULT"
            class="shrink-0 z-[999]"
        />

        <!-- 主内容区域 -->
        <div class="flex flex-col flex-1 h-full overflow-hidden">
            <router-view></router-view>
        </div>
    </div>
</template>

<script setup lang="ts">
import { NavBar, NAV_MENU_TYPE } from '@eureka/shared/nav-bar';
import { useHeaderService } from '@/composables/use-header-service';

const { headerService } = useHeaderService();
</script>
